import '../utils/icons-outline/style.scss';
import '../utils/styles/base/_icons.scss';
import React, { createContext, useContext } from 'react';
const ThemeContext = /*#__PURE__*/createContext();
export const ThemeProvider = _ref => {
  let {
    children,
    theme
  } = _ref;
  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: {
      theme
    }
  }, children);
};
export const useTheme = () => {
  return useContext(ThemeContext) || 'light';
};